
import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";
import { vsLookupManagementServiceProviderName as projectCostLookupManagementServiceProviderName } from "."
export const vsObjectName = "projectCostType";

export const projectCostTypeConfig = simpleLookupConfig(projectCostLookupManagementServiceProviderName, {
  name: vsObjectName,
  nameSingular: "Project Cost Type",
  namePlural: "Project Cost Types",
  url: "/api/project/projectCostType",
  defaultSort: "Name",
  additionalColumns: [
    ColumnDefinitionServiceName,
    (columnDefinitionService: ColumnDefinitionService) => [
      columnDefinitionService.getNumberColDef({
        field: "Rate",
      }),
    ],
  ],
  additionalFields: [
    () => [
      fieldHelpers.simpleNumberField({
        key: "Rate",
        required: true,
      }),
    ],
  ],
})

